import {
  getFormattedPrices,
  type ProductForPriceFormatting,
} from '@/features/shop/components/VerticalProduct/utils'
import { type ShoppingListProduct } from '@/features/shop/services/ShoppingLists/types'
import { isValid, min } from 'date-fns'

export const getTotalListCost = (products: ProductForPriceFormatting[]) => {
  const totalPrice = products
    .reduce((total, product) => {
      const { formattedTotalPrice } = getFormattedPrices(product, undefined)
      return Number(formattedTotalPrice.replace(/\$/g, '')) + total
    }, 0)
    .toFixed(2)

  return { totalPrice }
}

export const getNextCommonAutoAtcDate = (products: ShoppingListProduct[]) => {
  const dates = products
    .reduce<Date[]>((acc, curr) => {
      if (curr.next_auto_atc_date) {
        return [...acc, new Date(curr.next_auto_atc_date)]
      } else {
        return acc
      }
    }, [])
    .filter(isValid)
  return dates.length ? min(dates) : undefined
}
